import { FunctionComponent } from "react";
import { UseFormRegister } from "react-hook-form";


interface IFileUploadProps {
    label: string;
    name: string;
    register: UseFormRegister<any>;
    error?: string;
    containerStyles?: string;
    accept?: string;
    required?: boolean;
}


const FileUpload: FunctionComponent<IFileUploadProps> = ({
    label,
    name,
    register,
    error,
    containerStyles = '',
    accept = "image/*",
    required = false
}) => {
    return (
        <div className={`mb-6 ${containerStyles}`}>
            <label 
                htmlFor={name}
                className="block text-sm font-medium text-gray-700 mb-2"
            >
                {label} {required && <span className="text-red-500">*</span>}
            </label>
            
            <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md hover:border-primary transition-colors">
                <div className="space-y-1 text-center">
                    <svg
                        className="mx-auto h-12 w-12 text-gray-400"
                        stroke="currentColor"
                        fill="none"
                        viewBox="0 0 48 48"
                    >
                        <path
                            d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                    <div className="flex text-sm text-gray-600">
                        <label
                            htmlFor={name}
                            className="relative cursor-pointer bg-white rounded-md font-medium text-primary hover:text-primary-dark focus-within:outline-none"
                        >
                            <span>Upload a file</span>
                            <input
                                id={name}
                                type="file"
                                accept={accept}
                                className="sr-only"
                                {...register(name)}
                            />
                        </label>
                        <p className="pl-1">or drag and drop</p>
                    </div>
                    <p className="text-xs text-gray-500">PNG, JPG up to 5MB</p>
                </div>
            </div>
            
            {error && (
                <p className="mt-1 text-sm text-red-600">{error}</p>
            )}
        </div>
    );
};


export default FileUpload;


